import { useEffect } from 'react';

import { IKeyboardAction } from '../interfaces/IKeyboardAction';
import { KeyActionsTagEnum } from '../enums/KeyActionsTagEnum';

export function useKeyUp(
  handler: () => void,
  keyboardActions: IKeyboardAction[],
  tag: KeyActionsTagEnum
): void {
  useEffect(() => {
    const maybeHandler = (ev: KeyboardEvent): void => {
      const { keyCode } = ev;

      const findAction = keyboardActions?.find(
        (keyAction) => keyAction.keyCode === keyCode
      );

      if (findAction) {
        if (findAction.tag === tag) {
          handler();
        }
      }
    };

    window.addEventListener('keyup', maybeHandler);

    return () => window.removeEventListener('keyup', maybeHandler);
  }, [keyboardActions, handler, tag]);
}
